import { render, staticRenderFns } from "./ResponseList.vue?vue&type=template&id=a5fa49b4&scoped=true&"
import script from "./ResponseList.vue?vue&type=script&lang=js&"
export * from "./ResponseList.vue?vue&type=script&lang=js&"
import style0 from "./ResponseList.vue?vue&type=style&index=0&id=a5fa49b4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5fa49b4",
  null
  
)

export default component.exports